import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PROMOTED_PETITIONS_IN_FOOTER_WELL = createFcmConfig('promoted_petitions_in_footer_well', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
